import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import { Button, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { ReactComponent as CsvIcon } from "../../../assets/icons/csv.svg";
import BulkAddDashboardsModal from "../../modals/home/BulkAddDashboardsModal";

const useStyles = makeStyles((theme) => ({
    container: {
        width: 350,
        height: 180,
        border: `2px solid ${theme.colors.neutral['200']}`,
        borderRadius: 24,
        padding: 16,
    },
    headerIcon: {
        color: theme.colors.neutral['400'],
        width: 60,
        height: 60,
    },
    subText: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 400,
        color: theme.colors.neutral['500'],
    },
    text: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.neutral['700'],
    },
    link: {
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: theme.colors.primary['700'],
        cursor: 'pointer',
    },
    mainIcon: {
        width: 60,
        height: 60,
    },
    icon: {
        width: 24,
        height: 24,
    },
    button: {
        minWidth: 150,
        borderRadius: 24,
        fontFamily: 'Lato',
        fontSize: '0.95rem',
        fontWeight: 'bold !important',
        textTransform: 'none !important' as any,
        transition: 'ease-in-out 300ms',
    },
}));

const CompanyBulkCSVCard: React.FC<{}> = () => {
    const classes = useStyles();
    const [bulkAddModalOpen, setBulkAddModalOpen] = useState<boolean>(false);

    return (<>
        <Stack className={classes.container} spacing={2} alignItems="center" justifyContent="center">
            <CsvIcon className={classes.headerIcon} />
            <Typography className={classes.subText}>
                {'Upload by CSV'}
            </Typography>
            <Button variant="contained"
                className={classes.button}
                startIcon={<IosShareRoundedIcon className={classes.icon} />}
                onClick={() => setBulkAddModalOpen(true)}>
                {'Upload CSV'}
            </Button>
        </Stack>
        {bulkAddModalOpen && (
            <BulkAddDashboardsModal
                isOpen={bulkAddModalOpen}
                onClose={() => setBulkAddModalOpen(false)}
            />
        )}
    </>);
}

export default CompanyBulkCSVCard;